import {
  Backbone,
  Button,
  Column,
  Horizontal,
  Picture,
  Row,
  Spacer,
  Text
} from '@smuchile/pkg-unimarc-components'
import Image from 'next/future/image'
import { useContentful } from '@smuchile/pkg-unimarc-hooks'
import { NO_RESULT_CHEESE } from 'shared/utils/constanst'
import { useRouter } from 'next/router'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'

export interface WithoutProductsProps {
  hasFiltersApplied?: boolean
  isMobile?: boolean
}

export const WithoutProducts = ({
  hasFiltersApplied,
  isMobile
}: WithoutProductsProps) => {
  const router = useRouter()
  const isSearchPage = router.asPath.includes('search')
  const widthButton = isMobile ? '311px' : '408px'
  const widhtCondition = isMobile ? '245px' : '314px'
  const heightCondition = isMobile ? '140px' : '178px'
  const spacerCondition1 = isMobile ? 12 : 14
  const spacerCondition2 = isMobile ? 4 : 8
  const titleFontSize = isMobile ? 'xl' : '2xl'
  const isSearchWithoutFacets = isSearchPage && !hasFiltersApplied
  const title1 = isSearchWithoutFacets
    ? `No encontramos resultados`
    : '¡Ups! Lo sentimos'

  const query = router.query.q || ''
  const title2Before = ` para tu búsqueda “`
  const title2After = `”`

  const subTitle1 = isSearchWithoutFacets
    ? '✅ Prueba revisando la ortografía'
    : 'La búsqueda no arrojó resultados.'

  const subTitle2 = isSearchWithoutFacets
    ? '✅ Usa términos menos específicos'
    : 'Prueba cambiando o eliminando'

  const subTitle3 = isSearchWithoutFacets ? '' : 'algunos filtros.'

  const noResultCheese = useContentful({
    id_contentful: 'queso_sin_resultados',
    options: {
      'sys.id': NO_RESULT_CHEESE[0]
    },
    type: 'assets'
  })
  const noResultCheeseImage =
    noResultCheese?.data?.['items']?.[0]?.fields?.file?.url || ''

  /*get granade image for suggestions empty response */
  const imgEmptySuggestions = useContentful({
    id_contentful: 'granada_sin_resultados',
    options: {
      'sys.id': '5BYiu08I2t8UiCvgfhv27U'
    },
    type: 'assets'
  })
  const imageEmptySuggestion =
    imgEmptySuggestions?.data?.['items'][0]?.fields?.file?.url || ''

  const handleSeeMoreOffersButton = () => {
    router.push('/')
  }
  return (
    <Column
      alignItems='center'
      justifyContent='center'
    >
      {isMobile && isSearchWithoutFacets && (
        <Spacer.Horizontal customSize={140} />
      )}
      {noResultCheese.isLoading || imgEmptySuggestions.isLoading ? (
        <Row maxWidth='250px'>
          <Backbone
            borderRadius='8px'
            height={249}
            width={249}
          />
        </Row>
      ) : (
        <Picture
          alt='imagen para pagina sin resultados'
          anchor
          height={isSearchWithoutFacets ? heightCondition : '100%'}
          nextImage={Image}
          src={
            isSearchWithoutFacets ? imageEmptySuggestion : noResultCheeseImage
          }
          title={`${
            isSearchWithoutFacets ? 'granada' : 'queso'
          } sin resultados`}
          url={
            isSearchWithoutFacets ? imageEmptySuggestion : noResultCheeseImage
          }
          width={isSearchWithoutFacets ? widhtCondition : '251px'}
        />
      )}

      <Horizontal customSize={isSearchWithoutFacets ? spacerCondition1 : 16} />
      <Text
        fontSize={isSearchWithoutFacets ? titleFontSize : '2xl'}
        fontWeight={isSearchWithoutFacets ? 'medium' : 'semibold'}
      >
        {title1}
        {!isMobile && isSearchWithoutFacets && (
          <>
            <span style={{ marginRight: '5px' }} />
            <span>{title2Before}</span>
            <Text
              color='red'
              fontSize='2xl'
              fontWeight='medium'
            >
              {query}
            </Text>
            <span>{title2After}</span>
          </>
        )}
      </Text>

      {isSearchWithoutFacets && isMobile && (
        <Text
          display='flex'
          fontSize='xl'
          fontWeight='medium'
        >
          <span>{title2Before}</span>
          <Text
            color='red'
            fontSize='xl'
            fontWeight='medium'
          >
            {query}
          </Text>
          <span>{title2After}</span>
        </Text>
      )}

      <Horizontal customSize={isSearchWithoutFacets ? spacerCondition1 : 16} />
      <Text
        fontSize={isMobile ? 'lg' : 'xl'}
        fontWeight='regular'
      >
        {subTitle1}
      </Text>
      {isSearchWithoutFacets && <Horizontal customSize={spacerCondition2} />}
      <Text
        fontSize={isMobile ? 'lg' : 'xl'}
        fontWeight='regular'
      >
        {subTitle2}
      </Text>
      <Text
        fontSize={isMobile ? 'lg' : 'xl'}
        fontWeight='regular'
      >
        {subTitle3}
      </Text>
      <Spacer.Horizontal customSize={23} />
      {!isSearchWithoutFacets && (
        <Button
          borderRadius={getGlobalStyle('--border-radius-xl')}
          fontSize={getGlobalStyle('--font-size-base')}
          fontWeight={getGlobalStyle('--font-weight-medium')}
          label='Ver otras ofertas'
          onClick={handleSeeMoreOffersButton}
          width={widthButton}
        />
      )}
    </Column>
  )
}
